import { Plus, X } from 'lucide-react';
import { LiksButton } from '../../components/liks/LiksButton/LiksButton';
import { LiksDropdown } from '../../components/liks/LiksDropdown/LiksDropdown';

type AssignmentChip = {
  id: string;
  name: string;
};

type DropdownOption = {
  value: string;
  label: string;
};

type TenantUserAssignmentBlockProps = {
  heading: string;
  emptyLabel: string;
  chips: ReadonlyArray<AssignmentChip>;
  chipModifierClassName?: string;
  removeAriaLabel: (name: string) => string;
  onRemove: (id: string) => void;
  selectedId: string;
  onSelectedIdChange: (value: string) => void;
  options: ReadonlyArray<DropdownOption>;
  selectPlaceholder: string;
  selectAriaLabel: string;
  addLabel: string;
  onAdd: () => void;
  pendingId: string | null;
};

export function TenantUserAssignmentBlock({
  heading,
  emptyLabel,
  chips,
  chipModifierClassName,
  removeAriaLabel,
  onRemove,
  selectedId,
  onSelectedIdChange,
  options,
  selectPlaceholder,
  selectAriaLabel,
  addLabel,
  onAdd,
  pendingId,
}: TenantUserAssignmentBlockProps) {
  return (
    <div className="tenant-user-assignments-card__block">
      <h3 className="tenant-user-assignments-card__heading">{heading}</h3>
      {chips.length === 0 ? (
        <p className="tenant-user-assignments-card__status">{emptyLabel}</p>
      ) : (
        <div className="tenant-user-assignments-card__chips">
          {chips.map((chip) => (
            <span
              key={chip.id}
              className={[
                'tenant-user-assignments-card__chip',
                chipModifierClassName,
              ]
                .filter(Boolean)
                .join(' ')}
            >
              <span className="tenant-user-assignments-card__chip-label">
                {chip.name}
              </span>
              <button
                type="button"
                className="tenant-user-assignments-card__chip-remove"
                disabled={pendingId === chip.id}
                aria-label={removeAriaLabel(chip.name)}
                onClick={() => onRemove(chip.id)}
              >
                <X strokeWidth={2} aria-hidden />
              </button>
            </span>
          ))}
        </div>
      )}
      <div className="tenant-user-assignments-card__add-row">
        <LiksDropdown
          className="tenant-user-assignments-card__dropdown"
          variant="on-light"
          value={selectedId}
          onChange={onSelectedIdChange}
          options={[
            {
              value: '',
              label: selectPlaceholder,
            },
            ...options,
          ]}
          aria-label={selectAriaLabel}
          disabled={options.length === 0}
        />
        <LiksButton
          type="button"
          disabled={selectedId === '' || pendingId === selectedId}
          onClick={onAdd}
        >
          <Plus strokeWidth={2} aria-hidden />
          {addLabel}
        </LiksButton>
      </div>
    </div>
  );
}
